import { Internal_CheckPermissions } from "@swivl-mono/helpers";
import { APIScope, SWIVL_STAFF_KINDS } from "@swivl-mono/types";

import AccountModel from "../../Models/Account/AccountModel";
import RolesModel from "../../Models/Roles/Roles.Model";

export function useHasPermission(scope?: APIScope, groupId?: number, locationId?: number) {
  const { defaultRoles, parentRoles, roles } = RolesModel.useState();
  const { member, account } = AccountModel.useState((s) => s);

  if (account?.kind && SWIVL_STAFF_KINDS.includes(account.kind)) {
    return true;
  }
  if (!scope || !member || !roles) {
    return false;
  }
  const mergedParents = { ...(defaultRoles ?? {}), ...(parentRoles ?? {}) };
  const has = Internal_CheckPermissions(mergedParents, roles, member.permissions, scope, member.orgId, groupId, locationId);

  return has;
}
